/* Product gallery only. No-ops when #SlidesCon is absent (homepage).
   Role, name, and the visually hidden status node are rendered in product-media-gallery.liquid.
   Thumbnails #gst-* and prev/next stay native buttons. */
(function () {
  var root = document.getElementById("SlidesCon");
  if (!root) return;

  var thumbButtons = Array.prototype.filter.call(
    document.querySelectorAll('button[id^="gst-"]'),
    function (button) {
      return /^gst-\d+$/.test(button.id);
    }
  );
  var slideNodes = root.querySelectorAll(".product-media-image");
  var total = thumbButtons.length || slideNodes.length;
  if (!total) return;

  var status = document.getElementById("SlidesConStatus");
  if (!status) return;

  var index = indexFromThumbs();

  function indexFromThumbs() {
    for (var i = 0; i < thumbButtons.length; i++) {
      if (thumbButtons[i].classList.contains("active")) return i + 1;
    }
    return 1;
  }

  function announce() {
    status.textContent = "Image " + index + " of " + total;
  }

  function buttonByLabel(label) {
    var buttons = document.querySelectorAll("button");
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute("aria-label") === label) return buttons[i];
    }
    return null;
  }

  var arrows = document.querySelector(".gallery-slider-arrows");
  var thumbs = document.querySelector(".gallery-slider-thumbnails");
  var scope = root;
  var node = root;
  while (node.parentElement) {
    var parent = node.parentElement;
    var hasArrows = !arrows || parent.contains(arrows);
    var hasThumbs = !thumbs || parent.contains(thumbs);
    if (hasArrows && hasThumbs) {
      scope = parent;
      break;
    }
    node = parent;
  }

  function step(delta) {
    var next = index + delta;
    if (next < 1) next = total;
    if (next > total) next = 1;
    return next;
  }

  scope.addEventListener("keydown", function (event) {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
    if (!scope.contains(event.target)) return;
    event.preventDefault();
    var before = index;
    var label = event.key === "ArrowRight" ? "Next product image" : "Previous product image";
    var control = buttonByLabel(label);
    if (control) control.click();
    var fromDom = indexFromThumbs();
    if (fromDom !== before) {
      index = fromDom;
    } else {
      index = step(event.key === "ArrowRight" ? 1 : -1);
    }
    announce();
  });

  scope.addEventListener("click", function (event) {
    var control = event.target.closest ? event.target.closest("button") : null;
    if (!control) return;
    var thumbIndex = thumbButtons.indexOf(control);
    if (thumbIndex >= 0) {
      index = thumbIndex + 1;
      announce();
      return;
    }
    if (
      control.classList.contains("slider-arrow-left") ||
      control.classList.contains("slider-arrow-right")
    ) {
      var fromDom = indexFromThumbs();
      if (fromDom !== index) index = fromDom;
      announce();
    }
  });

  announce();
})();
